<div class="toggled doNotPrint" id="wrapper">
  <div id="sidebar-wrapper" class="d-md-flex">
    <div class="d-md-none">
      <div class="d-flex justify-content-center align-items-center">
        <img class="img-thumbnail img-fluid border rounded-circle border-primary shadow m-3 thumbnail" src="../assets/image/man-avatar.png" data-bs-toggle="modal" data-target="#editProfile" (click)="toggleSidebar()" />
        <div class="text-center">
          <span class="userName"
            ><strong>{{ sharedService.getLoggedInUsername() | uppercase }}</strong></span
          >
          <div class="text-center d-md-flex justify-content-md-center userType">
            <span>{{ getLoggedInRolename() | uppercase }}</span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <ul class="sidebar-nav my-md-auto">
      @if (sharedService.isRoles([enums.BOSS, enums.FINANCE, enums.BRANCH_MANAGER, enums.BRANCH_MANAGER_HEAD, enums.BOOKKEEPING_STAFF, enums.STAFF, enums.ADMIN])) {
        <li>
          <a [routerLink]="checkDashboard()" [id]="getStyle(checkDashboard())" (click)="toggleSidebar()">Dashboard </a>
        </li>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.EXPENSE_ADMIN])) {
        <li>
          <a routerLink="/businessList" [id]="getStyle('/businessList')" (click)="toggleSidebar()">Business License</a>
        </li>
        <li>
          <a routerLink="/fiscal-year-list" [id]="getStyle('/fy-info-list')" (click)="toggleSidebar()">Fiscal Year Info</a>
        </li>
        <!-- <li>
          <a routerLink="/form-j-selection" [id]="getStyle('/form-j-selection')" (click)="toggleSidebar()">E-Invoice </a>
        </li> -->
        <li>
          <a routerLink="/e-invoice-dashboard" [id]="getStyle('/e-invoice-dashboard')" (click)="toggleSidebar()">E-Invoice </a>
        </li>
      }
      <!-- <li [hidden]="getLoggedInRoleID()==enums.STAFF">
                <a routerLink="/manageAsset" [id]="getStyle('/manageAsset')" (click)="toggleSidebar()">Assets </a>
            </li> -->
      <!-- <li *ngIf="getLoggedInRoleID()!=enums.STAFF">
                <a routerLink="/dashboard" [id]="getStyle('/dashboard')" (click)="toggleSidebar()">Transactions </a>
            </li> -->
      @if (sharedService.isRoles([enums.BOSS, enums.FINANCE, enums.ADMIN, enums.AUDITOR])) {
        <li>
          <a routerLink="/companyList" [id]="getStyle('/companyList')" (click)="toggleSidebar()">Companies </a>
        </li>
      }
       @if (sharedService.isRoles([enums.BOSS, enums.FINANCE])) {
        <li>
          <a routerLink="/faList" [id]="getStyle('/faList')" (click)="toggleSidebar()">Finance Accounts </a>
        </li>
      }
      @if (sharedService.isRoles([enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF])) {
        <li>
          <a [routerLink]="getCustomerListLink()" [id]="getStyle('/customerList')" (click)="toggleSidebar()">Customers </a>
        </li>
        <li>
          <a routerLink="/accountList" [id]="getStyle('/accountList')" (click)="toggleSidebar()">Accounts</a>
        </li>
        <li>
          <a [routerLink]="getAdvanceLink()" [id]="getStyle('/advanceList')" (click)="toggleSidebar()">Advance</a>
        </li>
        <li>
          <a routerLink="/commissionList" [id]="getStyle('/commissionList')" (click)="toggleSidebar()">Commission</a>
        </li>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.BRANCH_MANAGER, enums.BRANCH_MANAGER_HEAD, enums.BOOKKEEPING_STAFF, enums.ADMIN, enums.EXPENSE_ADMIN])) {
        <li>
          <a (click)="getReceiptMenu()" [id]="getStyle('/receiptList')" style="cursor: pointer">Receipts</a>
        </li>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.BRANCH_MANAGER, enums.BRANCH_MANAGER_HEAD, enums.ADMIN])) {
        <li>
          <a routerLink="/blacklistRecords" [id]="getStyle('/blacklistRecords')" (click)="toggleSidebar()">Blacklist </a>
        </li>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.FINANCE, enums.BRANCH_MANAGER, enums.BRANCH_MANAGER_HEAD, enums.ADMIN])) {
        <li>
          <a routerLink="/userList" [id]="getStyle('/userList')" (click)="toggleSidebar()">Users </a>
        </li>
        <li>
          <a routerLink="/cpReports" [id]="getStyle('/cpReports')" (click)="toggleSidebar()">CP</a>
        </li>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.FINANCE, enums.BRANCH_MANAGER, enums.BRANCH_MANAGER_HEAD, enums.BOOKKEEPING_STAFF, enums.ADMIN, enums.AUDITOR])) {
        <li>
          <a routerLink="/reportMenu" [id]="getStyle('/reportMenu')" (click)="toggleSidebar()">Report</a>
        </li>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.ADMIN])) {
        <li>
          <a routerLink="/register" [id]="getStyle('/register')" (click)="toggleSidebar()">Register</a>
        </li>
        <!-- <li> <a routerLink="/contact" [id]="getStyle('/contact')" (click)="toggleSidebar()">Contact</a></li> -->
        <li>
          <a routerLink="/import" [id]="getStyle('/import')" (click)="toggleSidebar()">Import</a>
        </li>
      }
      @if (sharedService.isRoles([enums.BOSS, enums.ADMIN_HEAD])) {
        <li>
          <a routerLink="/adminAccessManagement" [id]="getStyle('/adminAccessManagement')" (click)="toggleSidebar()"> Access Control</a>
        </li>
      }
      @if (enums.draftEPFLimitList != undefined) {
        <li>
          <a routerLink="/draft-calculator" [id]="getStyle('/draft-calculator')" (click)="toggleSidebar()">Calculator</a>
          <span class="badge text-bg-danger" style="text-indent: 0; font-size: 10pt">New!</span>
        </li>
      }
      <li class="d-md-none" (click)="logout()"><a class="logoutLink">Logout</a></li>
    </ul>
  </div>
</div>
